import styled from 'styled-components';

import { SearchBox } from '@xing-com/crate-jobs-domain-search-components-search-box';
import { useSearchBar } from '@xing-com/crate-jobs-hooks';
import { mediaTopBarHidden } from '@xing-com/layout-tokens';

export const SearchBarLegacy: React.FC = () => {
  const { keywords, location, ...result } = useSearchBar();

  return (
    <Container>
      <SearchBox
        keywordsInput={keywords}
        locationInput={location}
        onSelectKeywords={result.onChangeKeywords}
        condensedOnMobile
        {...result}
      />
    </Container>
  );
};

const Container = styled.div`
  @media ${mediaTopBarHidden} {
    padding-top: 31px;
  }
`;
